import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Drawer,
  Tooltip,
  Card,
  Grid,
  CardContent,
} from "@mui/material";
import {
  DoubleArrow,
  Edit,
  CalendarMonth,
  AccessTimeRounded,
  HelpOutlineRounded,
} from "@mui/icons-material";
import { EditOTPreApproval } from "./EditOTPreApproval";
import { parentBoxStyle, infoStyle, themes } from "services/constants";
import { tooltipStyleProps } from "services/constants/Styles";
import { showToast } from "services/utils/Status";
import { UserDetailsRow } from "components/CustomComponents/UserDetailsRow";
import { drawerStyle } from "services/constants";

export const ViewOTPreApproval = ({
  onClose,
  editOTPreAppDetails,
  reCallApi,
  setGetId,
  setIsViewPanelOpen,
  setHandleLoader,
  screenAccess,
}) => {
  const [isEditPanelOpen, setIsEditPanelOpen] = useState(false);

  const handleEditOTPreApproval = () => {
    setIsEditPanelOpen(true);
  };

  const handleEditClosePanel = () => {
    setIsEditPanelOpen(false);
  };

  const handleCloseOTPreApproval = () => {
    if (isEditPanelOpen) {
      setIsEditPanelOpen(false);
      return;
    }
    setIsViewPanelOpen(false);
  };

  return (
    <>
      <Box sx={parentBoxStyle}>
        <Paper
          elevation={0}
          sx={{
            borderBottom: `1px solid ${themes?.miliedLightGray}`,
            borderRadius: 0,
          }}
        >
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                px: 1,
              }}
            >
              <IconButton
                onClick={onClose}
                sx={{
                  color: themes?.grayColor,
                  "&:hover": { backgroundColor: themes?.primary },
                }}
              >
                <DoubleArrow />
              </IconButton>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "50%",
                  padding: "4px 4px",
                  gap: 0.5,
                }}
              >
                <Tooltip title="Edit" arrow slotProps={tooltipStyleProps}>
                  <IconButton
                    onClick={() => {
                      if (screenAccess) {
                        handleEditOTPreApproval();
                      } else {
                        showToast(
                          "error",
                          `Access denied: You are not authorized to edit OT pre-approval.`
                        );
                      }
                    }}
                    sx={{
                      color: themes?.greenColor,
                      backgroundColor: themes?.primary,
                      borderRadius: "50%",
                      "&:hover": { backgroundColor: themes?.primary },
                    }}
                  >
                    <Edit />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>

            <Box sx={{ ml: 2.2 }}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                View OT Pre-Approval Request
              </Typography>
              <Typography {...infoStyle}>View your OT request</Typography>
            </Box>
          </Box>
        </Paper>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2.5,
            p: 2,
            pb: 0,
          }}
        >
          <Box>
            <UserDetailsRow
              userDetails={{
                image_url: editOTPreAppDetails?.image_url,
                employee_id: editOTPreAppDetails?.employee_id
                  ? editOTPreAppDetails?.employee_id
                  : "-",
                user_name: editOTPreAppDetails?.employee_name,
                department_name: editOTPreAppDetails?.department
                  ? editOTPreAppDetails?.department
                  : "-",
                designation: editOTPreAppDetails?.user_type
                  ? editOTPreAppDetails?.user_type
                  : "-",
              }}
            />
          </Box>
        </Box>

        <Box
          sx={{
            p: 2,
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <Card
                sx={{
                  bgcolor: "#FCECF7",
                  border: `1px solid #F7B7D3`,
                  height: "100%",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 1,
                    }}
                  >
                    <Box
                      sx={{
                        bgcolor: "#FCECF7",
                        p: 1,
                        borderRadius: 2,
                        display: "flex",
                        alignItems: "center",
                        border: `1px solid #F7B7D3`,
                      }}
                    >
                      <CalendarMonth sx={{ color: "#E64899", fontSize: 20 }} />
                    </Box>
                    <Typography
                      variant="subtitle1"
                      color="#000"
                      fontWeight="700"
                    >
                      Overtime Date / Period
                    </Typography>
                  </Box>
                  <Typography
                    variant="body1"
                    fontWeight="600"
                    color="#000"
                    sx={{
                      whiteSpace: "pre-line",
                      wordBreak: "break-word",
                      fontSize: "17px",
                    }}
                  >
                    {editOTPreAppDetails?.ot_date
                      ? editOTPreAppDetails?.ot_date
                      : "N/A"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Card
                sx={{
                  bgcolor: "#EAF2FC",
                  border: `1px solid #9FC4F7`,
                  height: "100%",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 1,
                    }}
                  >
                    <Box
                      sx={{
                        bgcolor: "#EAF2FC",
                        p: 1,
                        borderRadius: 2,
                        display: "flex",
                        alignItems: "center",
                        border: `1px solid #9FC4F7`,
                      }}
                    >
                      <AccessTimeRounded
                        sx={{ color: "#1E88E5", fontSize: 20 }}
                      />
                    </Box>
                    <Typography
                      variant="subtitle1"
                      color="#000"
                      fontWeight="700"
                    >
                      Duration in Hrs
                    </Typography>
                  </Box>
                  <Typography
                    variant="body1"
                    fontWeight="600"
                    color="#000"
                    sx={{
                      whiteSpace: "pre-line",
                      wordBreak: "break-word",
                      fontSize: "17px",
                    }}
                  >
                    {editOTPreAppDetails?.ot_duration
                      ? editOTPreAppDetails?.ot_duration
                      : "N/A"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Card
                sx={{
                  bgcolor: "#EDF8F0",
                  border: `1px solid #8AD0A0`,
                  height: "100%",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 1,
                    }}
                  >
                    <Box
                      sx={{
                        bgcolor: "#EDF8F0",
                        p: 1,
                        borderRadius: 2,
                        display: "flex",
                        alignItems: "center",
                        border: `1px solid #8AD0A0`,
                      }}
                    >
                      <CalendarMonth sx={{ color: "#2E7D32", fontSize: 20 }} />
                    </Box>
                    <Typography
                      variant="subtitle1"
                      color="#000"
                      fontWeight="700"
                    >
                      Applicable Timing
                    </Typography>
                  </Box>
                  <Typography
                    variant="body1"
                    fontWeight="600"
                    color="#000"
                    sx={{
                      whiteSpace: "pre-line",
                      wordBreak: "break-word",
                      fontSize: "17px",
                    }}
                  >
                    {editOTPreAppDetails?.ot_consideration
                      ? editOTPreAppDetails?.ot_consideration
                      : "N/A"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Card
                sx={{
                  bgcolor: "#FFF7E8",
                  border: `1px solid #F1D39C`,
                  height: "100%",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 1,
                    }}
                  >
                    <Box
                      sx={{
                        bgcolor: "#FFF7E8",
                        p: 1,
                        borderRadius: 2,
                        display: "flex",
                        alignItems: "center",
                        border: `1px solid #F1D39C`,
                      }}
                    >
                      <HelpOutlineRounded
                        sx={{ color: "#F9A825", fontSize: 20 }}
                      />
                    </Box>
                    <Typography
                      variant="subtitle1"
                      color="#000"
                      fontWeight="700"
                    >
                      Reason
                    </Typography>
                  </Box>
                  <Typography
                    variant="body1"
                    fontWeight="600"
                    color="#000"
                    sx={{
                      whiteSpace: "pre-line",
                      wordBreak: "break-word",
                      fontSize: "17px",
                    }}
                  >
                    {editOTPreAppDetails?.reason
                      ? editOTPreAppDetails?.reason
                      : "N/A"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Drawer
        anchor="right"
        open={isEditPanelOpen}
        onClose={(event, reason) => {
          isEditPanelOpen ? handleEditClosePanel() : handleCloseOTPreApproval();
        }}
        sx={drawerStyle}
      >
        {isEditPanelOpen ? (
          <EditOTPreApproval
            onClose={handleEditClosePanel}
            editOTPreAppDetails={editOTPreAppDetails}
            reCallApi={reCallApi}
            setGetId={setGetId}
            setHandleLoader={setHandleLoader}
          />
        ) : null}
      </Drawer>
    </>
  );
};
